import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Textarea } from '../ui/textarea';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Send, MessageCircle, ImagePlus } from 'lucide-react';
import LazyImage from '../LazyImage';

const CircleFeedTab = ({ posts, newPost, setNewPost, handleCreatePost, postImages, setPostImages, handlePostImageUpload, uploadingPostImage, BACKEND_URL }) => (
  <div className="space-y-6">
    <Card className="surface-card">
      <div className="p-6">
        <h3 className="text-lg font-semibold text-foreground mb-3">Share an Update</h3>
        <form onSubmit={handleCreatePost} className="space-y-4">
          <Textarea
            placeholder="What's on your mind?"
            value={newPost.content}
            onChange={(e) => setNewPost({ ...newPost, content: e.target.value })}
            data-testid="post-content-input"
            className="resize-none"
            rows={3}
          />
          <div className="flex items-center justify-between">
            <Select value={newPost.post_type} onValueChange={(value) => setNewPost({ ...newPost, post_type: value })}>
              <SelectTrigger className="w-40" data-testid="post-type-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="need">Need</SelectItem>
                <SelectItem value="support">Support</SelectItem>
                <SelectItem value="update">Update</SelectItem>
              </SelectContent>
            </Select>
            <Button type="submit" className="btn-primary" data-testid="submit-post-btn">
              <Send className="w-4 h-4 mr-2" /> Post
            </Button>
          </div>
          {postImages.length > 0 && (
            <div className="flex gap-2 mt-2">
              {postImages.map((path, idx) => (
                <div key={`preview-${idx}`} className="relative w-16 h-16 rounded-lg overflow-hidden">
                  <LazyImage src={`${BACKEND_URL}/api/files/${path}`} alt="" className="w-full h-full rounded-lg overflow-hidden" />
                  <button type="button" onClick={() => setPostImages(prev => prev.filter((_, i) => i !== idx))} className="absolute top-0 right-0 w-5 h-5 bg-black/50 text-white text-[10px] rounded-bl-lg flex items-center justify-center">&times;</button>
                </div>
              ))}
            </div>
          )}
          <div className="mt-2">
            <label className="text-xs text-cyan-600 font-medium cursor-pointer hover:text-cyan-700 flex items-center gap-1">
              <ImagePlus className="w-3.5 h-3.5" />
              {uploadingPostImage ? 'Uploading...' : 'Add Photo'}
              <input type="file" accept="image/*" className="hidden" onChange={handlePostImageUpload} disabled={uploadingPostImage} data-testid="post-image-input" />
            </label>
          </div>
        </form>
      </div>
    </Card>

    <div className="space-y-4">
      {posts.length > 0 ? posts.map((post) => (
        <Card key={post.id} className="surface-card" data-testid={`post-${post.id}`}>
          <CardContent className="pt-6">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-gradient-to-r from-cyan-500 to-emerald-500 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                {post.user?.name?.charAt(0)}
              </div>
              <div className="flex-1 space-y-2">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="font-semibold text-foreground">{post.user?.name}</p>
                    <p className="text-sm text-muted-foreground">{new Date(post.created_at).toLocaleString()}</p>
                  </div>
                  <span className="px-3 py-1 bg-cyan-100 dark:bg-cyan-900/30 text-cyan-700 dark:text-cyan-300 text-xs font-medium rounded-full">{post.post_type}</span>
                </div>
                <p className="text-foreground">{post.content}</p>
                {post.image_urls && post.image_urls.length > 0 && (
                  <div className="mt-3 grid grid-cols-2 gap-2">
                    {post.image_urls.map((url, idx) => (
                      <LazyImage key={`img-${idx}`} src={`${BACKEND_URL}/api/files/${url}`} alt="" className="rounded-xl w-full max-h-48 overflow-hidden" />
                    ))}
                  </div>
                )}
              </div>
            </div>
          </CardContent>
        </Card>
      )) : (
        <div className="text-center py-12">
          <MessageCircle className="w-16 h-16 text-muted-foreground/30 mx-auto mb-4" />
          <p className="text-muted-foreground">No posts yet. Be the first to share!</p>
        </div>
      )}
    </div>
  </div>
);

export default CircleFeedTab;
